import { ColumnKind, FilterOperator } from '../schemas'
import { TableSourceQuery } from './schemas'
import { FilterColumn } from '../components/TableFilters'

export const sourceStatusLabels = {
  ready: 'Awaiting analysis',
  pending: 'Queued',
  running: 'Processing',
  completed: 'Completed',
  failed: 'Failed',
  cancelled: 'Cancelled',
}
export const sourceColumns: (FilterColumn & { id: TableSourceQuery['sorts'][number]['column_id'] })[] = [
  {
    id: 'document_name',
    name: 'Source file',
    kind: ColumnKind.Text,
    tags: [],
    filterOperators: [FilterOperator.Contains, 'not_contains', FilterOperator.Equals],
  },
  {
    id: 'status',
    name: 'Status',
    kind: ColumnKind.Text,
    tags: [],
    filterOperators: [FilterOperator.Equals],
    filterOptions: Object.values(sourceStatusLabels).sort(),
  },
  {
    id: 'rows_created',
    name: 'Rows',
    kind: ColumnKind.Number,
    tags: [],
    filterOperators: [FilterOperator.Equals, FilterOperator.Greater, FilterOperator.Less],
  },
]
export const defaultSourceQuery: TableSourceQuery = { filters: [], sorts: [], offset: 0, limit: 100 }
